import { useSelector } from "react-redux";
import { StateExtended } from "../../interfaces/StateExtended";

export function useJobListSelector() {
  const jobs = useSelector((state: StateExtended) => state.job.jobs);
  return jobs;
}

export function useJobCandidatesSelector() {
  const jobCandidates = useSelector((state: StateExtended) => state.job.jobCandidates);
  return jobCandidates;
}

export function useScreeningDataSelector() {
  const screeningData = useSelector((state: StateExtended) => state.job.screeningData);
  return screeningData;
}
